import client from './client';

export type PartnerTermSection = {
  title: string;
  major?: boolean;
  center?: boolean;
  paragraphs?: string[];
  items?: { label: string; text: string }[];
};

export type PartnerPricing = {
  partner_buy_rate?: string;
  partner_residual_base_rate?: string;
  partner_volume_threshold?: string;
  partner_support_buy_rate?: string;
};

export type BrandConfig = {
  audience?: 'partner' | 'merchant';
  brand_name: string;
  logo_url: string | null;
  favicon_url: string | null;
  contact_phone: string;
  contact_email: string;
  primary_color: string;
  background_color: string;
  primary_text_color?: string;
  background_text_color?: string;
  intro_video_url?: string | null;
  merchant_conditions_url?: string | null;
  distributor_id?: number;
  merchant_pricing?: {
    sim_tms_monthly?: string;
    telemetry_monthly?: string;
    flair_cards_monthly?: string;
    corelink_16_monthly?: string;
  };
  register_authorize_requirements?: {
    hasWhatsAppSupportAdded?: {
      enabled: boolean;
      text?: string;
      contact_number?: string;
    };
    registeredTma?: {
      enabled: boolean;
      text?: string;
      register_url?: string;
    };
    authorizedDirectDebit?: {
      enabled: boolean;
      text?: string;
      payment_url?: string;
      pricing?: string;
    };
    signedContract?: {
      enabled: boolean;
      text?: string;
      uk_sign_url?: string;
      eu_sign_url?: string;
      uk_template_id?: string;
      eu_template_id?: string;
    };
    awareDemoMode?: {
      enabled: boolean;
      text?: string;
    };
    acceptTerms?: {
      enabled: boolean;
      text?: string;
      title?: string;
      url?: string;
    };
  };
  partner_pricing?: PartnerPricing;
  partner_conditions?: {
    title?: string;
    intro?: string;
    sections?: PartnerTermSection[];
  };
  partner_agreement?: {
    enabled?: boolean;
    text?: string;
    uk_sign_url?: string;
    eu_sign_url?: string;
    uk_template_id?: string;
    eu_template_id?: string;
  };
};

export function isPartnerAudience() {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname.toLowerCase();
  const audience = new URLSearchParams(window.location.search).get('audience');
  return host.startsWith('partner.') || audience === 'partner';
}

export async function fetchBrand(hostname: string): Promise<BrandConfig> {
  const params: { host: string; audience?: string } = { host: hostname };
  if (isPartnerAudience()) params.audience = 'partner';
  const res = await client.get('/onboarding/brand', { params });
  return res.data as BrandConfig;
}


